import { Box, Button, Container, Grid, List, ListItem, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { JSX } from 'react';

const Footer = (): JSX.Element => {
  const footerSections = [
    {
      title: 'Legal',
      links: [
        { text: 'Terms of Service', path: '/terms-of-service' },
        { text: 'Privacy Policy', path: '/privacy-policy' },
        { text: 'Support', path: 'mailto:support@groupmychannels.com' },
      ],
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="h6" component="div" sx={{ fontWeight: 700, mb: 2 }}>
              Group My Channels
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Group My Channels helps you organise your YouTube subscriptions into custom groups for faster discovery
              and a cleaner feed.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 8 }}>
            <Grid container spacing={2}>
              {footerSections.map((section, index) => (
                <Grid size={{ xs: 6, md: 4 }} key={index}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                    {section.title}
                  </Typography>
                  <List dense disablePadding>
                    {section.links.map((link, linkIndex) => (
                      <ListItem key={linkIndex} disablePadding sx={{ mb: 0.5 }}>
                        <Button
                          component={RouterLink}
                          to={link.path}
                          color="inherit"
                          sx={{
                            color: 'text.secondary',
                            p: 0,
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                          }}
                        >
                          {link.text}
                        </Button>
                      </ListItem>
                    ))}
                  </List>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
          © {new Date().getFullYear()} Group My Channels. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
